/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "star",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#FFDE00",
                "stroke": "#F7CF1B",
                "strokeMiterlimit": "10"
            },
            "star": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "20.4",
            "height": "19.4"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20.4 19.4", className: "star", width: this.props.width, height: this.props.height, style: this.props.star },
            _react2["default"].createElement("path", { className: "st0", d: "M10.2 14.6l-5.5 3.7 1.8-6.4-5.1-4 6.5-.3 2.3-6.2 2.3 6.2 6.5.3-5.1 4 1.8 6.4z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/star.js